import { useCallback, useRef, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { ReportPreferences, ReportTemplateContent } from "../../db/schema";
import PreferencesForm from "./PreferencesForm";
import ReportTemplateManager, {
  ReportTemplateManagerHandle,
} from "./ReportTemplates/ReportTemplateManager";

const Preferences = () => {
  const { user, setReportPreferences } = useAuth();
  const templateRef = useRef<ReportTemplateManagerHandle>(null);
  const initialTemplateContent = useRef<string | null>(null);
  const [templateDirty, setTemplateDirty] = useState(false);

  const handleTemplateContentChange = useCallback(
    (content: ReportTemplateContent) => {
      // Capture the first value as the baseline
      if (initialTemplateContent.current === null) {
        initialTemplateContent.current = JSON.stringify(content);
      }
      setTemplateDirty(
        JSON.stringify(content) !== initialTemplateContent.current
      );
    },
    []
  );

  return (
    <div className="flex-1 p-6 flex flex-col w-full prose items-center overflow-y-auto mt-8 md:mt-0">
      <div className="max-w-5xl mt-8 w-full">
        <h1 className="text-4xl font-semibold text-black-400 dark:text-base-content capitalize w-full text-center">
          Report Preferences
        </h1>

        <div className="mt-6">
          <PreferencesForm
            entityName={user?.name || undefined}
            entityBadge={user?.badgeID || undefined}
            entityId={user?.id}
            entityType="user"
            fetchEndpoint="/api/settings/report-preferences"
            saveEndpoint="/api/settings/report-preferences"
            externalDirty={templateDirty}
            onPreferencesSaved={(prefs) =>
              setReportPreferences(prefs as ReportPreferences)
            }
            onAfterSave={async () => {
              await (templateRef.current?.save() ?? Promise.resolve());
              initialTemplateContent.current = null;
              setTemplateDirty(false);
            }}
          >
            <ReportTemplateManager
              ref={templateRef}
              onContentChange={handleTemplateContentChange}
            />
          </PreferencesForm>
        </div>
      </div>
    </div>
  );
};

export default Preferences;
